<app-form-generator
    [formGeneratorInput]="createTicketFormGenInput"
></app-form-generator>
